import axios from "axios";

const fetchAppMeta = async () => {
  try {
    const response = await axios.get("/meta.json");
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      console.warn("Could not fetch meta.json:", error.message);
    } else {
      console.error("Unexpected error fetching meta.json:", error);
    }
    return undefined;
  }
};

export default fetchAppMeta;
